import WorkLogReport from "../../models/WorkLogReport";
import { Popover } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TableBasedCrud from "../../external/ensolvers-core-frontend-mui/components/TableBaseCrud";
import WorkLog from "../../models/WorkLog";
import { useTranslation } from "react-i18next";
import { WorklogModalCreation } from "../Worklog/WorklogModalCreation";
import OpsDateUtils from "../../utils/OpsDateUtils";
import useWorkLogPopup from "../../hooks/useWorkLogPopup";

const useStyles = makeStyles(
  {
    tableContainer: {
      "& .MuiTableCell-root": {
        padding: "0.5rem",
      },
    },
    paperGrowUp: {
      top: "auto !important",
    },
  },
  { index: 1 },
);

interface Props {
  report: WorkLogReport;
  date: Date;
  day?: number;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
  onWorkLogUpdate: (worLog: WorkLog, prevInternalHours: number) => void;
}

function WorkLogPopup({ report, date, day, anchorEl, onClose, onWorkLogUpdate }: Props) {
  const { t } = useTranslation();

  const {
    user,
    holidays,
    position,
    openForm,
    setOpenForm,
    handleFetchWorkLogs,
    handleUpdateWorkLog,
    saveWorkLog,
    handleOpenForm,
    workLogForEdit,
    setWorkLogForEdit,
  } = useWorkLogPopup({ report, date, day, onWorkLogUpdate });

  const classes = useStyles();
  const VIEWPORT_MARGIN = 16;

  const anchorRect = anchorEl?.getBoundingClientRect();

  const openUpwards = !!anchorRect && anchorRect.top > window.innerHeight - anchorRect.bottom;

  const paperStyle = !anchorRect
    ? undefined
    : openUpwards
      ? { bottom: window.innerHeight - anchorRect.top, maxHeight: anchorRect.top - VIEWPORT_MARGIN }
      : { maxHeight: window.innerHeight - anchorRect.bottom - VIEWPORT_MARGIN };

  return (
    <>
      <Popover
        className={classes.tableContainer}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: openUpwards ? "top" : "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: openUpwards ? "bottom" : "top", horizontal: "left" }}
        PaperProps={{
          className: openUpwards ? classes.paperGrowUp : undefined,
          style: paperStyle,
        }}
      >
        <TableBasedCrud<WorkLog>
          highlightOnHover={true}
          elementName={"Weekly Worklog"}
          denseTable={true}
          disableAutoFetch
          onDataFetch={handleFetchWorkLogs}
          renderDialogContent={() => <></>}
          hideActions={true}
          enablePagination={false}
          tableColumns={[
            {
              header: t("Date"),
              content: (instance) => (
                <span id={`day-${instance.shortDay.getDate ? instance.shortDay.getDate() : new Date(instance.shortDay).getDate()}`}>
                  {OpsDateUtils.formatUTCAsDDMMM(instance?.shortDay)}
                </span>
              ),
            },
            {
              header: t("Hours"),
              content: (instance) => <>{instance?.hours > 0 ? instance.hours : ""}</>,
            },
            {
              header: t("Description"),
              content: (instance) => <>{instance.description}</>,
            },
            {
              header: t("Internal Hours"),
              content: (instance) => <>{instance?.internalHours > 0 ? instance.internalHours : ""}</>,
            },
          ]}
          onElementClick={handleOpenForm}
        />
      </Popover>
      {!!workLogForEdit && (
        <WorklogModalCreation
          open={openForm}
          setOpen={setOpenForm}
          isEditMode={!!workLogForEdit.externalId}
          setIsEditMode={() => {}}
          workLog={workLogForEdit}
          setWorkLog={setWorkLogForEdit}
          holidays={holidays}
          paramUserExternalId={report.coreUserExternalId}
          user={user!}
          position={position}
          onSaveWorkLog={saveWorkLog}
          onModalClose={handleUpdateWorkLog}
        />
      )}
    </>
  );
}

export default WorkLogPopup;
